import React from 'react';
import { useNavigate } from 'react-router-dom';
import { services } from '../data/mockData';
import { ArrowRight, Phone } from 'lucide-react';
import * as Icons from 'lucide-react';

const OurServicesSection = ({ onOpenContactForm }) => {
  const navigate = useNavigate();

  return (
    <section id="services" className="py-24 bg-cream-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-wine-500 mb-3">Our Services</p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-wine-950">
            Trademark, Copyright &<br/><span className="text-wine-600">Business Formation</span> Services
          </h2>
          <p className="text-stone-500 text-base mt-4">
            End-to-end intellectual property and business services across the United States.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => {
            const IconComponent = Icons[service.icon];
            return (
              <div key={service.id} data-testid={`service-card-${service.id}`}
                onClick={() => navigate(service.path)}
                className="group cursor-pointer bg-white rounded-xl p-8 border border-stone-200 hover:border-gold-400 hover:-translate-y-1 hover:shadow-xl hover:shadow-gold-500/10 transition-all duration-300">
                <div className="w-11 h-11 bg-wine-50 rounded-lg flex items-center justify-center mb-5 group-hover:bg-wine-600 transition-colors duration-300">
                  {IconComponent && <IconComponent className="w-5 h-5 text-wine-600 group-hover:text-white transition-colors duration-300" strokeWidth={1.5} />}
                </div>
                <h3 className="text-lg font-semibold text-wine-950 mb-2 group-hover:text-wine-600 transition-colors">{service.title}</h3>
                <p className="text-sm text-stone-500 leading-relaxed mb-4">{service.description}</p>
                <span className="inline-flex items-center text-sm font-medium text-wine-600 group-hover:text-gold-600 transition-all">
                  Learn More <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
                </span>
              </div>
            );
          })}

          {/* 6th Box - CTA */}
          <div data-testid="service-cta-card" onClick={onOpenContactForm}
            className="group cursor-pointer bg-wine-600 rounded-xl p-8 border-2 border-wine-600 hover:bg-wine-700 hover:-translate-y-1 hover:shadow-xl hover:shadow-gold-500/15 transition-all duration-300 flex flex-col justify-center items-center text-center">
            <div className="w-14 h-14 bg-white/20 rounded-full flex items-center justify-center mb-5 group-hover:bg-gold-500 transition-colors duration-300">
              <Phone className="w-6 h-6 text-white group-hover:text-wine-950 transition-colors duration-300" strokeWidth={1.5} />
            </div>
            <h3 className="text-xl font-bold text-white mb-2">Get Free Consultation</h3>
            <p className="text-sm text-wine-200 leading-relaxed mb-5">Not sure which service you need? Talk to our experts for a free consultation.</p>
            <span className="inline-flex items-center text-sm font-semibold text-gold-400 group-hover:text-gold-300 transition-all">
              Contact Us Now <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurServicesSection;
